import { lazy } from 'react'

export default {
    path: '/voci-contratto/:voceContrattoId',
    title: 'Voce di costo: {{params.voceContrattoId}}',
    component: lazy(() => import('./detail'))
}